import { render, staticRenderFns } from "./systemrules.vue?vue&type=template&id=06c14233&"
import script from "./systemrules.vue?vue&type=script&lang=js&"
export * from "./systemrules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports